import script from "./FinishedProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinishedProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./FinishedProjectsPage.vue?vue&type=style&index=0&id=ed4b09d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed4b09d4"]])

export default __exports__